module.exports = __webpack_public_path__ + "static/img/Logo.5c43c28f.png";